/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * TODO:
 * Schedule appointment for review.
 */

import { Icons, OrgStatus, TypeComponentsItems } from 'interfaces'

export const shallowCompare = function <T extends Record<string, any>>(
	obj1: T,
	obj2: T
): boolean {
	const obj1Keys = Object.keys(obj1)
	const obj2Keys = Object.keys(obj2)
	let value = true

	if (obj1Keys.length !== obj2Keys.length) {
		value = false
	}

	obj1Keys.forEach((key): void => {
		if (obj1[key] !== obj2[key]) {
			value = false
		}
	})

	return value
}

export const getNameComponentForType = (value: TypeComponentsItems): string => {
	const typeToNameMap: Record<TypeComponentsItems, string> = {
		social_media: 'Social Media',
		attachment: 'Attachments',
		link: 'Link',
		content: 'Content',
		mail: 'Mail',
		simple_text: 'Custom Text',
		location: 'Location',
		tags: 'Tags',
		phone: 'Phone',
		title: 'Title',
		assets: 'Images or video',
		documents: 'Documents',
		missing_key: 'Missing Key Description'
	}

	return typeToNameMap[value] || 'N/A'
}

export const orgStatusLabel = {
	[OrgStatus.lite]: 'Lite',
	[OrgStatus.pro]: 'Pro',
	[OrgStatus.elite]: 'Elite',
	[OrgStatus.demo]: 'Demo'
}

export const orgStatusIcon = {
	[OrgStatus.lite]: Icons.lite,
	[OrgStatus.pro]: Icons.pro,
	[OrgStatus.elite]: Icons.elite,
	[OrgStatus.demo]: Icons.demo
}

export const getOrgStatus = (
	status?: OrgStatus | null
): { label: string; icon: string } => {
	if (!status) return { label: 'Select', icon: Icons.ticket }

	const label = orgStatusLabel?.[status] ?? 'Select'
	const icon = orgStatusIcon?.[status] ?? Icons.ticket

	return { label, icon }
}
